























import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import { Howl } from 'howler';

export default Vue.extend({
  components: {
    activity: Activity,
  },
  props: ['videoPlayer', 'drillPhrase', 'activityIndex', 'activityDataLength'],
  data() {
    return {
      deviceRecordedRepeated: 0,
      deviceRecordedPlayer: null as Howl | null, //  new Howl({}),
      navigationVisible: false,
    };
  },
  watch: {
    '$store.state.globalVolume': function (value) {
      if (this.deviceRecordedPlayer) {
        this.deviceRecordedPlayer.volume(value);
      }
    },
  },
  methods: {
    activityReady() {
      this.deviceRecordedRepeated = 0;
      (this.$refs.activity as any).startPlaying();
    },
    audioPlayed() {
      if (this.deviceRecordedPlayer) {
        this.playDeviceRecorded();
      } else {
        (this.$refs.activity as any).recordDevice();
      }
    },
    async onNext() {
      this.navigationVisible = false;
      this.deviceRecordedPlayer = null;
      await BbTools.sleepCancelable(LearningTools.TO_HIDE_ACTIVITY, this.$store);
      this.$emit('next');
    },
    playDeviceRecorded() {
      if (this.deviceRecordedPlayer) {
        this.deviceRecordedPlayer.play();
      }
    },
    deviceRecorded(payload: any) {
      if (this.deviceRecordedPlayer) this.deviceRecordedPlayer!.unload();
      this.deviceRecordedPlayer = new Howl({
        src: payload.dataURL,
        format: ['wav'],
        preload: false,
        autoplay: true,
        onend: this.deviceRecordedPlayed,
        volume: this.$store.state.globalVolume * 1.3,
      });
      this.deviceRecordedPlayer!.load();
    },
    async deviceRecordedPlayed() {
      this.deviceRecordedRepeated += 1;
      await BbTools.sleepCancelable(LearningTools.TO_AFTER_RECORDED, this.$store);
      if (this.deviceRecordedRepeated !== -1) { // if activity has not been stopped during sleep
        if (this.deviceRecordedRepeated < BbTools.REPEAT_RECORDED) {
          (this.$refs.activity as any).playAudio();
        } else {
          this.navigationVisible = true;
        }
      }
    },
    /* async checkNext() {
      if (this.$store.state.user.autoPlayNext) {
        await BbTools.sleepCancelable(LearningTools.TO_AFTER_RECORDED, this.$store);
        this.$refs.activity.onNext();
      }
    }, */
    activityStopped() {
      this.deviceRecordedRepeated = -1;
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
    if (this.deviceRecordedPlayer) {
      this.deviceRecordedPlayer.unload();
    }
  },
});
